import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Drawer, DrawerProps, Flex, Input, Select, Typography } from 'antd';
import cn from 'classnames';

import { EFilters, useFilters } from 'features/Filters';
import { CATEGORIES_OPTIONS } from 'shared/consts/categories';
import { useMedia } from 'shared/hooks';

import styles from './TransactionFilterDrawer.module.scss';

interface ITransactionFilterDrawerProps extends DrawerProps {
	onClose: () => void;
}

export const TransactionFilterDrawer: FC<ITransactionFilterDrawerProps> = ({ className, onClose, ...props }) => {
	const { t } = useTranslation();
	const isMobile = useMedia();
	const { getFilterValue, onFilterChange} = useFilters();
	const [category, setCategory] = useState(getFilterValue(EFilters.CATEGORY));
	const [socialMedia, setSocialMedia] = useState(getFilterValue(EFilters.SOCIAL_MEDIA));
	const [priceFrom, setPriceFrom] = useState(getFilterValue(EFilters.PRICE_FROM) || '');
	const [priceUntil, setPriceUntil] = useState(getFilterValue(EFilters.PRICE_UNTIL) || '');

	const handleApplyClick = () => {
		const fieldsArr = [];
		const valueArr = [];
		if (category) {
			fieldsArr.push(EFilters.CATEGORY);
			valueArr.push(category);
		}
		if (socialMedia) {
			fieldsArr.push(EFilters.SOCIAL_MEDIA);
			valueArr.push(socialMedia);
		}
		if (priceFrom) {
			fieldsArr.push(EFilters.PRICE_FROM);
			valueArr.push(priceFrom);
		}
		if (priceUntil) {
			fieldsArr.push(EFilters.PRICE_UNTIL);
			valueArr.push(priceUntil);
		}
		onFilterChange(fieldsArr, null, undefined, valueArr);
		onClose();
	};

	const handleClearClick = () => {
		setCategory(null);
		setSocialMedia(null);
		setPriceFrom('');
		setPriceUntil('');
		onFilterChange([EFilters.CATEGORY, EFilters.SOCIAL_MEDIA, EFilters.PRICE_FROM, EFilters.PRICE_UNTIL], null, undefined, [null, null, null, null]);
		onClose();
	};

	return (
		<Drawer
			title={t('Filters')}
			open={props.open}
			onClose={onClose}
			size={isMobile ? 'large' : 400}
			// placement="bottom"
			destroyOnHidden
			{...props}
			className={cn(className, styles.drawer)}>
			<Flex gap={24} vertical>
				<Flex vertical gap={8}>
					<Typography.Text className={styles.title}>{t('Task category:')}</Typography.Text>
					<Select
						placeholder={t('Select Task Category')}
						className={styles.postForm__w100}
						allowClear
						options={CATEGORIES_OPTIONS}
						value={category}
						onChange={setCategory}
					/>
				</Flex>
				<Flex vertical gap={8}>
					<Typography.Text className={styles.title}>{t('Social media:')}</Typography.Text>
					<Select
						placeholder={t('Select Social Media')}
						className={styles.postForm__w100}
						allowClear
						options={CATEGORIES_OPTIONS}
						value={socialMedia}
						onChange={setSocialMedia}
					/>
				</Flex>
				<Flex gap={12}>
					<Flex vertical gap={8}>
						<Typography.Text className={styles.title}>{t('Price from')}</Typography.Text>
						<Input
						placeholder={t('Enter price from')}
						suffix="USD"
						value={priceFrom}
						onChange={(e) => setPriceFrom(e.target.value)}
						maxLength={255} />
					</Flex>
					<Flex vertical gap={8}>
						<Typography.Text className={styles.title}>{t('Price until')}</Typography.Text>
						<Input
							placeholder={t('Enter price until')}
							suffix="USD"
							value={priceUntil}
							onChange={(e) => setPriceUntil(e.target.value)}
							maxLength={255} />
					</Flex>
				</Flex>
				<Flex justify='space-between'>
					<Button onClick={handleClearClick}>
						{t('Clear')}
					</Button>
					<Button onClick={handleApplyClick} disabled={!category && !socialMedia && !priceFrom && !priceUntil} type="primary">
						{t('Apply')}
					</Button>
				</Flex>
			</Flex>
		</Drawer>
	);
};
